<template>
  <div class="animated fadeIn" style="overflow-y:hidden">
    <div class="row">
      <div class="col">
        <span> Rows Per Page:</span>
        <!-- <input v-model="rowsPerPageC" type="number"/> -->
        <b-dropdown id="ddown3" :text="rowsPerPageCText" class="m-md-1" :disabled="showLoadingAnimation">
          <b-dropdown-item href="#" @click="rowsPerPageSelected(10)">10</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(20)">20</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(50)">50</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(100)">100</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(150)">150</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(200)">200</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(500)">500</b-dropdown-item>
          <b-dropdown-item href="#" @click="rowsPerPageSelected(1000)">1000</b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="col" align="center">
        <b-pagination 
          size="sm" 
          :total-rows="totalRowsC" 
          v-model="currentPage" 
          :per-page="rowsPerPageC" 
          hide-ellipsis
          :limit="paginationButtonsLimit" 
          align="center"
          @change="pageChanged"
          :disabled="disabledPagination"
          >
      </b-pagination>
      </div>
      <div class="col" align="right">
          <span>Total Rows {{totalRowsC}}</span>  
        </div>
    </div>

    <br/>
    <button type="button" class="btn btn-primary" @click="refreshTable()" :disabled="showLoadingAnimation">Refresh</button>
    <button type="button" class="btn btn-primary" @click="showCreateModal()" :disabled="showLoadingAnimation">New</button>
    <button type="button" class="btn btn-primary" @click="showSearchModal()" :disabled="showLoadingAnimation">Search</button>
    <b-table small bordered hover :items="tableRows" :fields="tableHeaders" @row-clicked="tableRowClicked">
    </b-table>

    <img src="static/img/Rolling.svg" alt="Loading data..." 
      style="margin-left:auto; margin-right:auto; display: block;"
      v-if="showLoadingAnimation">
    <p style="text-align: center"
      v-if="showLoadingError">
    Loading error:
    </p>
    <p style="text-align: center"
      v-if="showNoResult">
    No Result
    </p>

    <!-- Add customer Modal Component -->
    <b-modal id="modal1" title="Add New Customer Account" v-model="showCreateModalRef">
      <!-- Body -->
      <b-row class="mb-1">
        <b-col><label for="newCustomerAccount">Customer Account:</label></b-col>
        <b-col><input type="text" id="newCustomerAccount" placeholder="" v-model="newCustomerAccount"></b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col><label for="newCustomerName">Name:</label></b-col>
        <b-col><input type="text" id="newCustomerName" placeholder="" v-model="newCustomerName"></b-col>
      </b-row>
      <b-row>
        <b-col><label for="newCustomerError" style="color:red">{{newCustomerError}}</label></b-col>
        <!-- <b-col><input type="text" id="newCustomerError" placeholder="" v-model="newCustomerError"></b-col> -->
      </b-row>
      <!-- Footer -->
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" variant="primary" @click="addCustomerAccount()">
          Add
        </b-btn>
        <b-btn size="sm" class="float-right" variant="primary" @click="closeCreateModal()">
          Close
        </b-btn>
      </div>
    </b-modal>

    <!-- Search customer Modal Component -->
    <b-modal id="modal1" title="Search" v-model="showSearchModalRef">
      <!-- Body -->
      <b-row class="mb-1">
        <b-col><label for="searchCustomerAccount">Customer Account:</label></b-col>
        <b-col><input type="text" id="searchCustomerAccount" placeholder="" v-model="searchCustomerAccount"></b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col><label for="searchCustomerName">Name:</label></b-col>
        <b-col><input type="text" id="searchCustomerName" placeholder="" v-model="searchCustomerName"></b-col>
      </b-row>
      <!-- Footer -->
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" variant="primary" @click="searchCustomer()">
          Search
        </b-btn>
        <b-btn size="sm" class="float-right" variant="primary" @click="closeSearchModal()">
          Close
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentPage: this.$store.state.usrstomod.currentPage,
      paginationButtonsLimit: 3,
      selectedRowItem: null
    }
  },
  created: function () {
    this.$store.dispatch('cusaccmod/showAllCustomerAccounts')
  },
  updated: function () {
    // console.log('VUEJS updated hook!')
    let tableElement = document.getElementsByTagName('table')[0]
    let tableOriginalWidth = tableElement.offsetWidth
    // console.log('table width: ' + tableOriginalWidth)

    let tableHeaders = document.getElementsByTagName('th')
    // console.log('tableHeaders: ' + tableHeaders.length)
    let tableBodyCells = document.getElementsByTagName('td')
    // console.log('tableBodyCells: ' + tableBodyCells.length)
    if (tableHeaders.length > 0 && tableBodyCells.length > 0) {
      let totalColumnWidth = 0
      tableElement.style.width = (tableOriginalWidth * 2) + 'px'
      tableElement.style.maxWidth = (tableOriginalWidth * 2) + 'px'
      // console.log('Post Process: Updated table width to: ' + tableElement.offsetWidth)
      // let totalDiffs = 0
      for (let i = 0; i < tableHeaders.length; i++) {
        let headerWidth = tableHeaders[i].offsetWidth
        let cellWidth = tableBodyCells[i].offsetWidth
        // console.log(i + '-Header width: ' + headerWidth)
        // console.log(i + '-Cell width: ' + cellWidth)
        if (headerWidth < cellWidth) {
          tableHeaders[i].style.width = cellWidth + 'px'
          // console.log('updated header width to: ' + tableHeaders[i].getBoundingClientRect().width)
          totalColumnWidth = totalColumnWidth + tableHeaders[i].offsetWidth
        } else if (cellWidth < headerWidth) {
          tableBodyCells[i].style.width = headerWidth + 'px'
          // console.log('update cell width to: ' + tableBodyCells[i].getBoundingClientRect().width)
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth
        } else {
          totalColumnWidth = totalColumnWidth + tableBodyCells[i].offsetWidth
        }
      }
      if (totalColumnWidth > 0) {
        tableElement.style.width = totalColumnWidth + 'px'
        tableElement.style.maxWidth = totalColumnWidth + 'px'
        // console.log('Updated table width to: ' + tableElement.offsetWidth)
      }
    }
  },
  methods: {
    pageChanged: function (pageNumber) {
      this.currentPage = pageNumber
      console.log('User changed page to number: ' + this.currentPage)
      this.$store.commit('cusaccmod/changePageNumber', this.currentPage)
      this.$store.dispatch('cusaccmod/showAllCustomerAccounts')
    },
    rowsPerPageSelected: function (rows) {
      console.log('rowsPerPageSelected, rows: ' + rows)
      let intRows = parseInt(rows)
      if (this.$store.state.claimmod.rowsPerPage !== intRows) {
        this.currentPage = 1
        this.$store.commit('cusaccmod/changePageNumber', this.currentPage)
        this.$store.commit('cusaccmod/setRowsPerPage', intRows)
        this.$store.dispatch('cusaccmod/showAllCustomerAccounts')
      }
    },
    tableRowClicked: function (item, index, event) {
      console.log('Table row clicked')
      console.log('item: ' + item)
      this.$store.commit('cusaccmod/selectTableRow', item.docId)
      this.selectedRowItem = item
    },
    refreshTable: function () {
      this.currentPage = 1
      this.$store.commit('cusaccmod/changePageNumber', this.currentPage)
      this.$store.dispatch('cusaccmod/showAllCustomerAccounts')
    },
    showCreateModal: function () {
      this.$store.commit('cusaccmod/toggleShowCreateModal', true)
    },
    closeCreateModal: function () {
      this.$store.commit('cusaccmod/toggleShowCreateModal', false)
    },
    addCustomerAccount: function () {
      this.$store.dispatch('cusaccmod/addCustomerAccount')
    },
    showSearchModal: function () {
      this.$store.commit('cusaccmod/toggleShowSearchModal', true)
    },
    closeSearchModal: function () {
      this.$store.commit('cusaccmod/toggleShowSearchModal', false)
    },
    searchCustomer: function () {
      this.$store.dispatch('cusaccmod/searchCustomer')
    }
  },
  computed: {
    disabledPagination: function () {
      return this.$store.state.cusaccmod.disabledPagination
    },
    tableRows: function () {
      return this.$store.state.cusaccmod.all
    },
    tableHeaders: function () {
      return this.$store.getters['cusaccmod/getHeaders']
    },
    totalRowsC: function () {
      return this.$store.state.cusaccmod.totalRows
    },
    rowsPerPageC: {
      get: function () {
        return this.$store.state.cusaccmod.rowsPerPage
      },
      set: function (newValue) {
        this.$store.commit('cusaccmod/setRowsPerPage', newValue)
      }
    },
    rowsPerPageCText: function () {
      return '' + this.$store.state.cusaccmod.rowsPerPage
    },
    showCreateModalRef: {
      get: function () {
        return this.$store.state.cusaccmod.showCreateModal
      },
      set: function (newValue) {
        this.$store.commit('cusaccmod/toggleShowCreateModal', newValue)
      }
    },
    showSearchModalRef: {
      get: function () {
        return this.$store.state.cusaccmod.showSearchModal
      },
      set: function (newValue) {
        this.$store.commit('cusaccmod/toggleShowSearchModal', newValue)
      }
    },
    newCustomerAccount: {
      get: function () {
        return this.$store.state.cusaccmod.newCustomer.customerAccount
      },
      set: function (newValue) {
        this.$store.commit('cusaccmod/setNewCustomerAccount', newValue)
      }
    },
    newCustomerName: {
      get: function () {
        return this.$store.state.cusaccmod.newCustomer.name
      },
      set: function (newValue) {
        this.$store.commit('cusaccmod/setNewCustomerName', newValue)
      }
    },
    newCustomerError: function () {
      return this.$store.state.cusaccmod.newCustomer.error
    },
    searchCustomerAccount: {
      get: function () {
        return this.$store.state.cusaccmod.searchCustomer.customerAccount
      },
      set: function (newValue) {
        this.$store.commit('cusaccmod/setSearchCustomerAccount', newValue)
      }
    },
    searchCustomerName: {
      get: function () {
        return this.$store.state.cusaccmod.searchCustomer.name
      },
      set: function (newValue) {
        this.$store.commit('cusaccmod/setSearchCustomerName', newValue)
      }
    },
    showLoadingAnimation: function () {
      return this.$store.state.cusaccmod.showLoadingAnimation
    },
    showLoadingError: function () {
      return this.$store.state.cusaccmod.showLoadingError
    },
    showNoResult: function () {
      return this.$store.state.cusaccmod.showNoResult
    }
  },
  name: 'CustomerAccounts'
}
</script>


// WEBPACK FOOTER //
// src/views/CustomerAccounts.vue